/* tslint:disable */

declare var Object: any;
export interface TsfeedserviceInterface {
  "id"?: number;
}

export class Tsfeedservice implements TsfeedserviceInterface {
  "id": number;
  constructor(data?: TsfeedserviceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tsfeedservice`.
   */
  public static getModelName() {
    return "Tsfeedservice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tsfeedservice for dynamic purposes.
  **/
  public static factory(data: TsfeedserviceInterface): Tsfeedservice{
    return new Tsfeedservice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tsfeedservice',
      plural: 'Tsfeedservices',
      path: 'Tsfeedservices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tsfeedservice.ts